import React from 'react';
import PropTypes from 'prop-types';
import ListCaseStudies from '../../components/ListCaseStudies';

const HeroProjects = ({ input }) => {
  const source = input.items.map(({ project }) => project.document);

  return (
    <ListCaseStudies itemWidth={input.primary.item_width} input={source} />
  );
};

HeroProjects.propTypes = {
  input: PropTypes.object.isRequired,
};

export default HeroProjects;
